import { render, staticRenderFns } from "./joinClass.vue?vue&type=template&id=1964bcf6"
import script from "./joinClass.vue?vue&type=script&lang=js"
export * from "./joinClass.vue?vue&type=script&lang=js"
import style0 from "./joinClass.vue?vue&type=style&index=0&id=1964bcf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports